import { NextResponse } from 'next/server'

const contentType = "image/svg+xml"
const cacheControl = "public, max-age=0, must-revalidate"
const buffer = Buffer.from("PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIj4KICA8dGl0bGU+T3BlbkhpZ2dzZmllbGQgQUk8L3RpdGxlPgogIDxzdHlsZT4KICAgIC5wbGF0ZSB7IGZpbGw6ICMwZTEwMTEgfQogICAgLmVkZ2UgeyBzdHJva2U6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC4xMSkgfQogICAgQG1lZGlhIChwcmVmZXJzLWNvbG9yLXNjaGVtZTogZGFyaykgewogICAgICAucGxhdGUgeyBmaWxsOiAjMWExZDFmIH0KICAgICAgLmVkZ2UgeyBzdHJva2U6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC4xNikgfQogICAgfQogIDwvc3R5bGU+CiAgPHJlY3QgY2xhc3M9InBsYXRlIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHJ4PSI3LjUiIGZpbGw9IiMwZTEwMTEiLz4KICA8cmVjdCBjbGFzcz0iZWRnZSIgeD0iLjUiIHk9Ii41IiB3aWR0aD0iMzEiIGhlaWdodD0iMzEiIHJ4PSI3IiBmaWxsPSJub25lIiBzdHJva2U9InJnYmEoMjU1LDI1NSwyNTUsMC4xMSkiLz4KICA8ZyBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgIDxwYXRoIGQ9Ik0xOS41IDYuNUg4LjlBMi40IDIuNCAwIDAgMCA2LjUgOC45VjE3IiBzdHJva2U9IiNkMWZlMTciLz4KICAgIDxwYXRoIGQ9Ik0xMi41IDI1LjVIMjMuMWEyLjQgMi40IDAgMCAwIDIuNC0yLjRWMTUiIHN0cm9rZT0iI2MyYzljOCIvPgogIDwvZz4KPC9zdmc+Cg==", 'base64')

export function GET() {
    return new NextResponse(buffer, {
        headers: {
            'Content-Type': contentType,
            'Cache-Control': cacheControl,
        },
    })
}

export const dynamic = 'force-static'
